import React from 'react'
import { UseLayoutProps } from './layoutType'
import useWebService from '../../../services/web/useWebService'
import useAuthenStore from '../../../stores/authen/authenStore'
import useAppNotificationAction from '../../../stores/notification/appNotificationAction'
import useRouter from '../../../router/useRouter'
import { RoutePath } from '../../../router/routesConfig'
import useManageMenuAction from '../../../stores/manageMenu/useManageMenuAction'

const useLayout = (props: UseLayoutProps) => {
    const router = useRouter()
    const [open, setOpen] = React.useState(false)
    const appNotificationAction = useAppNotificationAction()
    const callWebService = useWebService()
    const profileStore = useAuthenStore()
    const { profile } = profileStore
    const manageMenuAction = useManageMenuAction()

    const [selectedMenu, setSelectedMenu] = React.useState<string>('private_playground')
    const [tabIndex, setTabIndex] = React.useState(0)
    React.useEffect(() => {
        getNotification()
    }, [profile.userId])
    const handleTogleSidebar = () => {
        setOpen(!open)
        manageMenuAction.setIsOpen(!open)
    }
    const handleSelectedMenu = (menuID: string) => {
        setSelectedMenu(menuID)
    }

    const getNotification = async () => {
        if (profile.userId) {
            const res = await callWebService.getNotificationInfo(profile.userId)

            let result = [...res.result]
            // const mock = {
            //     notifyID: 9999,
            //     // notifyMessageEN: 'Exceeded The deadline for submitting hard copy documents.',
            //     // notifyMessageTH: 'เลยกำหนดส่งเอกสาร Hard Copy แล้ว',
            //     notifyMessageEN: 'Exceeded The deadline for submitting hard copy documents.',
            //     notifyMessageTH: 'ใบรับรองหมดอายุแล้ว',
            //     notifyType: 'HARD_COPY',
            //     projectID: 131,
            //     projectNameEN: 'TEST-COMMENT-WITH-APPROVE-ADMIN',
            //     projectNameTH: 'TEST-COMMENT-WITH-APPROVE-ADMIN',
            //     projectNumber: '640060',
            //     submittedID: 191,
            // }
            // for (let i = 0; i < 5; i++) {
            //     if (i === 0 || i === 1) {
            //         result.push({ ...mock, isWatched: true })
            //     } else {
            //         result.push(mock)
            //     }
            // }
            appNotificationAction.setNotificationInfo(result)
        }
    }

    // const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    //     setTabIndex(newValue)
    // }

    const handleClickProfile = () => {
        router.goTo(RoutePath.preference)
    }

    return { open, handleTogleSidebar, selectedMenu, handleSelectedMenu, tabIndex, handleClickProfile }
}

export default useLayout
